import { OfficeIcon } from "@cmp-src/icons/TacticIcons/OfficeIcon";
import { Button } from "@cmp-src/primitives/button";
import type { Office } from "@gettactic/api";
import { LoadingSpinner } from "@gettactic/components/src/loadings/LoadingSpinner/LoadingSpinner";
import { cn } from "@gettactic/helpers";
import { Pencil } from "lucide-react";
import { GlobalSearchListItemLayout } from "../GlobalSearchListItemLayout";

interface OfficeItemProps {
  office: Office;
  isActive: boolean;
  onSelect: () => void;
  onEdit: () => void | Promise<void>;
  onReserve: () => void;
}

import { useState } from "react";

export function OfficeItem({
  office,
  isActive,
  onSelect,
  onEdit,
  onReserve
}: OfficeItemProps) {
  const [isLoading, setIsLoading] = useState(false);
  const isOffice = true;
  const location =
    office.city && office.state
      ? `${office.city}, ${office.state}`
      : office.address || undefined;

  return (
    <GlobalSearchListItemLayout
      isActive={isActive}
      onClick={onSelect}
      className={cn("justify-between gap-3 px-3 py-3")}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div
          className={cn(
            "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg align-middle",
            isOffice ? "bg-violet-500/10" : "bg-slate-500/10"
          )}
        >
          <OfficeIcon
            width={20}
            height={20}
            className={cn(
              "h-5 w-5",
              isOffice ? "text-violet-600" : "text-slate-600"
            )}
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-center gap-2">
            <span className="font-inter font-semibold text-[14px] text-neutral-1000">
              {office.name}
            </span>
          </div>
          <div className="flex items-center gap-3 font-inter font-medium text-[12px] text-neutral-700">
            {office.total_workspace_desks !== undefined && (
              <span>{office.total_workspace_desks} desks</span>
            )}
          </div>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button
          size="sm"
          variant="ghost"
          className="h-8 w-8 p-0"
          onClick={async (e) => {
            e.stopPropagation();
            setIsLoading(true);
            try {
              await onEdit();
            } catch (error) {
              console.error(error);
            } finally {
              setIsLoading(false);
            }
          }}
        >
          {isLoading ? (
            <LoadingSpinner className="h-3 w-3" />
          ) : (
            <Pencil className="h-3 w-3" />
          )}
        </Button>
        <Button
          size="sm"
          variant="outline"
          className="h-8 bg-transparent px-3"
          onClick={(e) => {
            e.stopPropagation();
            onReserve();
          }}
        >
          Reserve
        </Button>
      </div>
    </GlobalSearchListItemLayout>
  );
}
